import { HttpClient, HttpParams } from "@angular/common/http";
import { ProductCategoryDto, ProductCategoryList } from "./product-category.dto";
import { BehaviorSubject, map, Observable } from "rxjs";
import { inject, Injectable } from "@angular/core";
import { WorkFlowManagerDto } from "../work-flow-manager/work-flow-manager-dto";
import { EnvConfigService } from "app/env-config.service";

@Injectable({
  providedIn: "root",
})
export class ProductCategoryService {
  envConfig = inject(EnvConfigService);
  constructor(private http: HttpClient) {}

  public $selectedProductCategoryCode: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultProductCategoryCode());

  private defaultProductCategoryCode() {
    if (localStorage.getItem("productCategory")) {
      return localStorage.getItem("productCategory");
    } else {
      return this.envConfig.envConfig.defaultProductCategoryAdaptiveUICode;
    }
  }

  publishProductCategory(productCategory: string) {
    localStorage.setItem("productCategory", productCategory);
    this.$selectedProductCategoryCode.next(productCategory);
  }

  clearProductCategory() {
    localStorage.removeItem("productCategory");
    this.$selectedProductCategoryCode.next(this.defaultProductCategoryCode());
  }

  getSelectedProductCategoryCode(): string {
    if (this.$selectedProductCategoryCode.getValue()) {
      return this.$selectedProductCategoryCode.getValue();
    } else {
      return this.envConfig.envConfig.defaultProductCategoryAdaptiveUICode;
    }
  }

  findRecords(sort, pageIndex = 0, pageSize, columnName, columnValue): Observable<ProductCategoryList> {
    let params = new HttpParams().set("page", pageIndex).set("size", pageSize).set("sort", sort);
    if (columnName && columnValue) {
      params.set(columnName, columnValue);
    }
    return this.http
      .get<ProductCategoryDto[]>(`/api/product-category/pageable-list`, {
        observe: "response",
        params: params,
      })
      .pipe(
        map((response) => {
          return { data: response.body, totalCount: +response.headers.get("X-Total-Count") };
        }),
      );
  }

  getAllProductCategory(): Observable<ProductCategoryDto[]> {
    return this.http.get<ProductCategoryDto[]>(`/api/product-category/all`);
  }

  getPublishedProductCategory(): Observable<ProductCategoryDto[]> {
    return this.http.get<ProductCategoryDto[]>(`/api/product-category/published`);
  }

  getLoggedInUserProductCategory(): Observable<ProductCategoryDto[]> {
    return this.http.get<ProductCategoryDto[]>(`/api/product-category/logged-in-user`);
  }

  saveProducts(productCategory: ProductCategoryDto): Observable<ProductCategoryDto> {
    return this.http.post<ProductCategoryDto>(`/api/product-category/create`, productCategory).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  updateProducts(productCategory: ProductCategoryDto): Observable<ProductCategoryDto> {
    return this.http.put<ProductCategoryDto>(`/api/product-category/update`, productCategory).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  getById(id: string): Observable<ProductCategoryDto> {
    return this.http.get<ProductCategoryDto>(`/api/product-category/${id}`).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  getWorkFlowManagers(): Observable<WorkFlowManagerDto[]> {
    return this.http.get<WorkFlowManagerDto[]>(`/api/application/workFlowManagers`);
  }
}
